import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=00184977&scoped=true&"
import script from "./CardComponent.vue?vue&type=script&lang=js&"
export * from "./CardComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=00184977&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00184977",
  null
  
)

export default component.exports